import type {DestinationPointProps as Props} from '../types'

export function useDestinationPoint({name}: Props) {
  return {
    names: {
      address: `${name}.address`,
      contact: `${name}.contact`,
      parcels: `${name}.parcels.0.products.0.name`,
    },
  } as const
}
